import { useEffect } from 'react';

import { useFallbackUrl } from '../../__hooks/useFallbackUrl';
import { OPEN_CHATTY_EVENT } from '../../constants';

const FallBackUrl = () => {
    const openHelpUrl = useFallbackUrl();

    useEffect(() => {
        const openHelpUrlTrigger = () => {
            openHelpUrl();
        };

        document.addEventListener(OPEN_CHATTY_EVENT, openHelpUrlTrigger);

        return () => {
            document.removeEventListener(OPEN_CHATTY_EVENT, openHelpUrlTrigger);
        };
    }, [openHelpUrl]);

    return null;
};

export default FallBackUrl;
